import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { distinctUntilChanged, switchMap, withLatestFrom } from 'rxjs/operators';
import { BreakpointMinService } from 'src/app/@utils/breakpoint-min.service';

@Injectable({
    providedIn: 'root'
})
export class ScrollLockService {
    private scrollLockClass = 'kk-scroll-lock';
    private currentScroll = 0;

    public lockScroll$ = new BehaviorSubject<boolean>(false);

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private breakpointMinService: BreakpointMinService
    ) {
        this.lockScroll$
            .pipe(
                distinctUntilChanged(),
                withLatestFrom(this.breakpointMinService.breakpoint$),
                switchMap(([locked, { isMobile, isTablet }]) => of([locked, Boolean(isMobile || isTablet)]))
            )
            .subscribe(([locked, isDevice]) => {
                this.scrollLock(locked, isDevice);
            });
    }

    public scrollLock(isLocked: boolean = true, isDevice: boolean): void {
        const doc = this.document.documentElement;
        const body = this.document.body;

        // Handle devices
        if (isLocked && isDevice) {
            doc.style.overflow = 'hidden';
            doc.classList.add(this.scrollLockClass);
            body.classList.add(this.scrollLockClass);
            return;
        }

        // Handle desktop
        if (isLocked) {
            // Save current scroll for later use
            this.currentScroll = window.pageYOffset;
            doc.classList.add(this.scrollLockClass);
            // Drag doc down for correct scroll position
            doc.style.top = `-${this.currentScroll}px`;
            return;
        }

        // Reset everything
        doc.classList.remove(this.scrollLockClass);
        body.classList.remove(this.scrollLockClass);
        doc.style.top = '';
        doc.style.overflow = '';

        // On desktop restore scroll
        if (!isDevice) {
            doc.scrollTo(0, this.currentScroll);
        }
    }
}
